// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatSuggestedPrompt-moduleprompt__jf3Kj AIButtonContainedGrey-moduleaiButtonContainedGrey__DeVYQ";
var _2 = "GretaAIChatSuggestedPrompt-modulepromptLabel__yTHNu AIButtonContainedGrey-modulelabel__cW_ty";
export { _1 as "prompt", _2 as "promptLabel" }
